exports = module.exports = require("../../../../shared/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".client-teacher-note-html-display\n{\n}\n", ""]);

